import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * WordPress dependencies
 */
import { useContext } from '@wordpress/element';
/**
 * Internal dependencies
 */

import DropdownMenu from '../dropdown-menu';
import ToolbarContext from '../toolbar-context';
import ToolbarItem from '../toolbar-item';

function ToolbarGroupCollapsed(_ref) {
  var _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? [] : _ref$controls,
      toggleProps = _ref.toggleProps,
      props = _objectWithoutProperties(_ref, ["controls", "toggleProps"]);

  // It'll contain state if `ToolbarGroup` is being used within
  // `<Toolbar label="label" />`
  var accessibleToolbarState = useContext(ToolbarContext);

  var renderDropdownMenu = function renderDropdownMenu(internalToggleProps) {
    return createElement(DropdownMenu, _extends({
      controls: controls,
      toggleProps: _objectSpread(_objectSpread({}, internalToggleProps), {}, {
        'data-toolbar-item': true
      })
    }, props));
  };

  if (accessibleToolbarState) {
    return createElement(ToolbarItem, toggleProps, renderDropdownMenu);
  }

  return renderDropdownMenu(toggleProps);
}

export default ToolbarGroupCollapsed;
//# sourceMappingURL=toolbar-group-collapsed.js.map